import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioFormatoPagareService {

  constructor(private requestUrl: ReportesRequestService) { }

  async getEntidadEmpresarial(parametros: ParametrosPagareEntity, uncoEntidadEmpresarial: number) {
    try {
      const response = await this.requestUrl.getRequest(
        'entidad-empresarial/datos-entidad',
        [parametros.codigoBaseDatos, { unco_entidad_empresarial: uncoEntidadEmpresarial }]
      );
      return response;

    } catch (e) {
      alert(e);
      // console.log(`ServicioResolucion1552Service.getEntidadEmpresarial() ${e}`);
    }
    return null;
  }

  async getDataPagare(parametros: ParametrosPagareEntity) {
    try {
      const response = await this.requestUrl.getRequest(
        'formato-pagare/datos',
        [
          parametros.codigoBaseDatos,
          {
            'unco_admision': parametros.uncoAdmision
          }
        ]);
      return response;
    } catch (e) {
      console.log(`Servicio-formato-pagareService.getDataPagare() ${e}`);
    }
  }
}

export interface ParametrosPagareEntity {
  codigoBaseDatos: string;
  uncoSede: string;
  nombreSede: string;
  uncoEntidad: string;
  uncoAdmision: string;
}

export interface EntidadEmpresarial {
  unco: number;
  nombreEntidad: string;
  nit: string;
  digitoVerificacion: string;
  direccion: string;
  telefono: string;
  tipoDocumento: string;
}

export interface DatosPagareEntity {
  nombreAfiliado: string;
  identificacionAfiliado: string;
  direccionAfiliado: string;
  telefonoAfiliado: string;
  fechaIngreso: string;
  horaIngreso: string;
  minutoIngreso: string;
  sexo: string;
  tipoAfiliado: string;
  fechaSalida: string;
  horaSalida: string;
  minutoSalida: string;
  numeroAdmision: string;
  tipoAtencion: string;
  sede: string;
  puntoAtencion: string;
  municipio: string;
  departamento: string;
}

